import React from 'react';
import {Table} from '@tanstack/react-table';

interface DataContext {
  table: Table<any>;
}

export default function Pagination({table}: DataContext): React.JSX.Element {
  return table.getPageCount() > 1 ? (
    <ul className="vl-pager__list">
      {table.getCanPreviousPage() ? (
        <>
          <li className="vl-pager__element vl-u-hidden--s">
            <button
              className="vl-pager__element__cta vl-link vl-link--bold"
              onClick={() => table.setPageIndex(0)}
            >
              &lt;&lt;
              Eerste <span className="vl-u-visually-hidden"> 5 rijen</span>
            </button>
          </li>
          <li className="vl-pager__element">
            <button
              className="vl-pager__element__cta vl-link vl-link--bold"
              onClick={() => table.previousPage()}
            >
              &lt;
              Vorige <span className="vl-u-visually-hidden"> 5 rijen</span>
            </button>
          </li>
        </>
      ) : null}

      <li className="vl-pager__element">
        <button className="vl-pager__element__cta vl-link vl-link--bold">
          {table.getState().pagination.pageIndex + 1}
        </button>
      </li>

      {table.getCanNextPage() ? (
        <>
          <li className="vl-pager__element">
            <button
              className="vl-pager__element__cta vl-link vl-link--bold"
              onClick={() => table.nextPage()}
            >
              Volgende <span className="vl-u-visually-hidden"> 5 rijen</span>
              &gt;
            </button>
          </li>
          <li className="vl-pager__element vl-u-hidden--s">
            <button
              className="vl-pager__element__cta vl-link vl-link--bold"
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            >
              Laatste <span className="vl-u-visually-hidden"> 5 rijen</span>
              &gt;&gt;
            </button>
          </li>
        </>
      ) : null}
    </ul>
  ) : <></>;
}